import { useCallback, useEffect, useState } from 'react';
import { fetchFireIncidents } from '../api/fire';
import { fetchPanicIncidents } from '../api/panic';

const ACTIVE = new Set(['open', 'accepted']);

/**
 * Счётчики незакрытых тревожных и пожарных инцидентов для бейджей сайдбара.
 */
export function useOpenAlarmCounts(enabled = true) {
  const [panicCount, setPanicCount] = useState(0);
  const [fireCount, setFireCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const [panicRes, fireRes] = await Promise.all([
        fetchPanicIncidents({ status: 'active', limit: 100 }),
        fetchFireIncidents({ limit: 100 }),
      ]);
      const panicRows = Array.isArray(panicRes.data) ? panicRes.data : [];
      const fireRows = Array.isArray(fireRes.data) ? fireRes.data : [];
      setPanicCount(panicRows.filter((row) => ACTIVE.has(row.status)).length);
      setFireCount(fireRows.filter((row) => ACTIVE.has(row.status)).length);
    } catch {
      // сайдбар не блокируем при ошибке опроса
    }
  }, [enabled]);

  useEffect(() => {
    refresh();
    if (!enabled) return undefined;
    const timer = setInterval(refresh, 30000);
    const onFire = () => refresh();
    const onPanic = () => refresh();
    window.addEventListener('fireIncidentUpdated', onFire);
    window.addEventListener('panicIncidentUpdated', onPanic);
    return () => {
      clearInterval(timer);
      window.removeEventListener('fireIncidentUpdated', onFire);
      window.removeEventListener('panicIncidentUpdated', onPanic);
    };
  }, [enabled, refresh]);

  return { panicCount, fireCount, refresh };
}
